import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { newQuotePath, quotePath } from "@/lib/recordRoutes";

/** Supports legacy /commercial/crm/quotations/:qid links by forwarding to the canonical ?open= route. */
export default function LegacyQuoteRedirect() {
  const { qid } = useParams();
  const [sp] = useSearchParams();
  if (qid === "new") return <Navigate to={newQuotePath(sp.get("account") || sp.get("customer_id"))} replace />;
  return <Navigate to={quotePath(qid) || "/commercial/crm/quotations"} replace />;
}
